<script lang="ts">
  import { translation } from '$lib/locale/locale';
  import type { Tag } from '$lib/models/tag';
  import { capitalize } from '$lib/utils/string';
  import { AssetType } from '$lib/utils/asset';

  const { langHref } = translation();

  export let tags: Tag[];
  export let type: AssetType;
  export let max = 3;
  export let noLinks = false;
  export let noFollow = false;

  function getLink(tag: Tag) {
    if (type === AssetType.Track) {
      return langHref('/royalty-free-music/?tagId=' + tag.id);
    } else if (type === AssetType.SFX) {
      return langHref('/sound-effects/?tagId=' + tag.id);
    } else if (type === AssetType.Intro) {
      return langHref('/intros/?tagId=' + tag.id);
    }
    return '';
  }

  let items: Tag[] = [];
  $: if (tags) {
    const shortTags = tags.filter((tag) => tag.name.length <= 10);
    if (shortTags.length > 0) {
      items = shortTags.slice(0, max);
    } else {
      items = tags.slice(0, 1);
    }
  }
</script>

{#each items as item, i}
  {#if noLinks}
    <span class:first={i == 0}>{capitalize(item.name)}</span>{#if i < items.length - 1},&nbsp;{/if}
  {:else}
    <a rel={noFollow ? 'nofollow' : undefined} href={getLink(item)} class:first={i == 0}>
      {capitalize(item.name)}</a
    >{#if i < items.length - 1},&nbsp;{/if}
  {/if}
{/each}

<style lang="scss">
  @use 'sass:map';

  * {
    color: var(--text-secondary);
    font-size: 1rem;
  }

  a:hover {
    text-decoration: none;
    color: black;
  }

  .first {
    margin-left: 0.6rem;
  }
</style>
